module.exports = __webpack_public_path__ + "img/earthMap.7e9c0fca.jpg";